export default __webpack_public_path__ + "static/media/future-scenario-planning-template.0f7ad9d9.pptx";